// https://vuex.vuejs.org/en/mutations.html
import defaultState from "./state";

export default {
  resetState: state => {
    state = Object.assign({}, defaultState)
  },
    socket_connect (state) {
      console.log('store connected')
      this.$bus.$emit('store_connected', true)
      state.connected = true
    },
    socket_disconnect (state) {
      console.log('store disconnected')
      state.connected = false
      state.ready = false
      this.$bus.$emit('app_exit', false)
    },
    socket_ready (state) {
      console.log('store ready=>app-init')
      state.ready = true
      this.$bus.$emit('ready', true)
    }
}
